import { toast } from 'react-toastify';
import axios from 'axios';
import i18n from 'i18next';
import { urls } from '../router/urls';

const mime = require('mime-types');

export const downloadFile = (data, fileName, extension) => {
  let toastId = null;
  axios
    .get(data, {
      responseType: 'blob',
      timeout: 300000,
      onDownloadProgress: e => {
        let progress = e.loaded / e.total;

        if (toastId === null) {
          toastId = toast(i18n.t('toast_descarga_iniciada'), {
            progress: progress
          });
        } else {
          toast.update(toastId, {
            render:
              i18n.t('toast_descarga_iniciada') +
              ` (${Math.round(progress * 100)}%)`,
            progress: progress
          });
        }
      }
    })
    .then(response => {
      // Create an invisible A element
      const a = document.createElement('a');
      a.style.display = 'none';
      document.body.appendChild(a);

      // Set the HREF to a Blob representation of the data to be downloaded
      a.href = window.URL.createObjectURL(
        new Blob([response.data], { type: mime.lookup(extension) })
      );
      // Use download attribute to set set desired file name
      a.setAttribute('download', fileName + '.' + extension);

      // Trigger the download by simulating click
      a.click();

      // Cleanup
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
      toast.dismiss();
      toast.success(i18n.t('toast_descarga_finalizada'));
    })
    .catch(err => {
      toast.dismiss();
      toast.error(i18n.t('toast_descarga_error'));
    });
};

export const formatTypeIcon = format => {
  switch (format) {
    case 'Textual':
      return { icon: 'fas fa-align-justify', label: format };
    case 'Software':
      return { icon: 'far fa-window', label: format };
    case 'Interactivo':
      return { icon: 'far fa-gamepad', label: format };
    case 'Gráfico':
      return { icon: 'fas fa-images', label: 'Grafico' };
    case 'Sonoro':
      return { icon: 'far fa-music', label: format };
    case 'Audiovisual':
      return { icon: 'far fa-video', label: format };
    case 'Multimedia':
      return { icon: 'far fa-play-circle', label: format };
    default:
      return null;
  }
};

/*export const closeMenu = () => {
  let menu = document.querySelector('.page-sidebar');
  let rightValue = getComputedStyle(menu).right;
  let isOpen = !('-540px' === rightValue);
  let element = document.getElementsByClassName('ham-pwa');
  isOpen && element[0].click();
}; */

export const downloableExtensions = extension => {
  switch (extension) {
    case 'doc':
    case 'exe':
    case 'flv':
    case 'mdb':
    case 'mp4':
    case 'msi':
    case 'ppt':
    case 'rar':
    case 'swf':
    case 'txt':
    case 'web':
    case 'xls':
    case 'xlsx':
      return true;

    default:
      return false;
  }
};

export const isViewableResourceExtension = extension => {
  switch (extension) {
    case 'png':
    case 'jpg':
    case 'jpeg':
    case 'pdf':
    case 'mp3':
    case 'mp4':
      return true;
    default:
      return false;
  }
};

export const getTaxon = taxon => {
  let values = [];
  for (let i = 0; i < taxon.length; i++) {
    values.push(taxon[i].level_one[0].level_two.level_three);
  }
  return values;
};

export const getFilename = location => {
  let res = location.split('/');
  return res[res.length - 1];
};

export const isFileDownload = (extension, url) => {
  return !!(extension !== 'null' && url.startsWith('/recursos/'));
};

export const updateResourceDownloadsCount = objectId => {
  axios
    .post(urls.getResourceNumberTimesDownloadedURL(objectId))
    .catch(function(error) {});
};

export const addView = objectId => {
  axios
    .post(urls.getResourceNumberTimesViewedURL(objectId))
    .catch(function(error) {});
};
